import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import '../scripts/useHoverEffect';
import '../css/mainlockup.css';
import '../css/main.css';
import useDeviceType from '../scripts/useDeviceType';
import HomeMobileLayout from '../components/HomeMobileLayout';
import HomeDesktopLayout from '../components/HomeDesktopLayout';






const Home: React.FC = () => {
  const deviceType = useDeviceType();

  return (
    <div>
      <Navbar />

      {deviceType === 'mobile' && <HomeMobileLayout />}
      {deviceType === 'desktop' && <HomeDesktopLayout />}

      <Footer />
    </div>
  );
};

export default Home;